import {gql} from "@apollo/client";

export const GET_NEWSFEED = gql`
query GetNewsFeed {
  news
}`;
